"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClerkProvider = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var errors_1 = require("../errors");
var utils_1 = require("../utils");
var ClerkContextProvider_1 = require("./ClerkContextProvider");
var StructureContext_1 = require("./StructureContext");
function ClerkProviderBase(props) {
  var initialState = props.initialState,
    children = props.children,
    Clerk = props.Clerk,
    frontendApi = props.frontendApi,
    options = tslib_1.__rest(props, ["initialState", "children", "Clerk", "frontendApi"]);
  return react_1.default.createElement(StructureContext_1.StructureContext.Provider, {
    value: StructureContext_1.StructureContextStates.noGuarantees
  }, react_1.default.createElement(ClerkContextProvider_1.ClerkContextProvider, {
    initialState: initialState,
    isomorphicClerkOptions: {
      frontendApi: frontendApi || '',
      Clerk: Clerk,
      options: options
    }
  }, children));
}
var ClerkProvider = (0, utils_1.withMaxAllowedInstancesGuard)(ClerkProviderBase, 'ClerkProvider', errors_1.multipleClerkProvidersError);
exports.ClerkProvider = ClerkProvider;
ClerkProvider.displayName = 'ClerkProvider';